<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="">
        <div class="f-grid" style="margin: 0px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2">
              <span class="title-css">THÔNG TIN NHÀ THẦU</span>
            </div>
          </div>
        </div>
        <div class="f-grid" style="margin: 0px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
              <label :class="{'txt-right' : true, 'required' : is_required}">Công ty</label>
              <DropdownScrollable cusClass="m-0 cs-width" :loading="loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="items" :total="total" @keyup="emitEvent" @offset="changeOffset" :disabled="mode=='edit' || isView"/>
              <input class="input-group input_tmp_validator" id="company" />
            </div>
            <div class="mt-2">
              <label :class="{'txt-right' : true, 'required' : is_required}">Mã nhà thầu</label>
              <InputText :disabled="mode=='edit' || isView" v-model="code" @input="code = code.toUpperCase().replace(/\s/g,'')" id="code_add" type="text" class="input-text-box cs-input" maxLength="50" placeholder="Nhập (tối đa 50 ký tự)"/>
            </div>
            <div class="mt-2">
              <label class="txt-right required">Tên nhà thầu</label>
              <InputText :disabled="isView" v-model="name" id="name_add" type="text" class="input-text-box cs-input" maxLength="255" placeholder="Nhập (tối đa 255 ký tự)"/>
            </div>
            <!-- <div class="mt-2">
              <label class="txt-right required">Tên người quản lý</label>
              <InputText v-model="owner_name" id="owner_name_add" type="text" class="input-text-box cs-input" maxLength="255" placeholder="Nhập (tối đa 255 ký tự)"/>
            </div> -->
            <div class="mt-2">
              <label class="txt-right">Người phụ trách nhà thầu</label>
              <DropdownScrollable
                placeholder="Chọn"
                :showClear="true"
                cusClass="m-0 cs-width"
                :limit="users1_obj.limit"
                :loading="users1_obj.loading"
                v-model="selusers1"
                :disabled="isView"
                :options="users1_obj.items"
                :total="users1_obj.total"
                @keyup="emitEventUsers1"
                @offset="changeOffsetUsers1"
                @scroll="emitEventUsers1"
              />
              <input class="input_tmp_validator_r" id="selusers1_add" />
            </div>
            <div class="mt-2">
              <label class="txt-right">Khu vực</label>
              <DropdownScrollable
                placeholder="Chọn"
                :showClear="true"
                cusClass="m-0 cs-width"
                :limit="zone_obj.limit"
                :loading="zone_obj.loading"
                v-model="zone"
                :disabled="isView"
                :options="zone_obj.items"
                :total="zone_obj.total"
                @keyup="emitEventZone"
                @scroll="emitEventZone"
                @offset="changeOffsetZone"
                />
              <input class="input_tmp_validator" id="zone" />
            </div>
          </div>
          <div class="f-grid-col">
            <div class="mt-2">
              <label class="txt-right required">Số điện thoại</label>
              <InputText :disabled="isView" v-model="phone" id="phone_add" type="text" class="input-text-box cs-input" maxLength="15" placeholder="Nhập (tối đa 15 ký tự)"/>

            </div>
            <div class="mt-2">
              <label class="txt-right">Email</label>
              <InputText :disabled="isView" v-model="email" id="email_add" type="text" class="input-text-box cs-input" maxLength="255" placeholder="example@mail.com"/>
            </div>
            <div class="mt-2">
              <label class="txt-right">Dịch vụ</label>
              <InputText :disabled="isView" v-model="service_text" id="service_text_add" type="text" class="input-text-box cs-input" maxLength="255" placeholder="Nhập"/>
            </div>
            <div class="mt-2">
              <Checkbox v-model="active" :binary="true" :disabled="isView" /><span>Hoạt động</span>
            </div>
            <div class="mt-0">
              <span style="font-style: italic;">Nếu unactive toàn bộ tài khoản người dùng liên quan nhà thầu này sẽ bị khoá truy cập.</span>
            </div>
          </div>
        </div>
        <div class="f-grid" style="margin: 10px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2">
              <span class="title-css">HỒ SƠ CÔNG TY</span>
            </div>
          </div>
        </div>
        <div class="f-grid" style="margin: 0px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-3">
              <table id="tb_level">
                <tr>
                  <th style="width: 50px;">STT</th>
                  <th style="">Tên hồ sơ</th>
                  <th style="width: 260px;">Danh sách file</th>
                  <th v-if="!isView" style="width:90px">Hành động</th>
                </tr>
                <tr v-for="(item, index) in list_profile" :key="index">
                  <td>{{index+1}}</td>
                  <td>{{item.name}}</td>
                  <td>
                    <div v-if="item.files && item.files.length > 0" class="profile-file-list">
                      <div v-for="(file, fileIndex) in item.files" :key="fileIndex" class="profile-file-row">
                        <a href="#" class="profile-file-link" @click.prevent="viewFile(file)">{{file.name}}</a>
                        <Button icon="pi pi-download" class="p-button-download p-button-link" @click="downloadFile(file)"/>
                      </div>
                    </div>
                  </td>
                  <td v-if="!isView" style="text-align: center;" >
                    <Button
                      @click="ShowUpload(index)"
                      icon="pi pi-upload"
                      class="button-box p-button-add"
                    >
                    </Button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>

      <Toolbar v-if="!isView" class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else-if="mode == 'add'"
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>

      <Dialog header="Tải tệp" :visible.sync="showEditDialog" :contentStyle="{overflow: 'visible','overflow-y': 'scroll'}" :modal="true">
        <div style="padding-top: 0px;min-width:400px;">
          <input class="input_tmp_validator" id="files">
          <div class="cus-text">Dung lượng tối đa: 50 MB</div>
          <div class="cus-text">Định dạng file: docx, doc, xlsx, pptx, pdf, png, jpg, jpeg.</div>
          <input class="p-inputtext p-component text-box-a" multiple style="background-color: #EEEEEE;" accept=".docx, .doc, .xlsx, .xls, .pptx, .pdf, .png, .jpg, .jpeg" name="files[]" type="file" @change="onFileSelect2"/>
          <div v-if="loading" class="loading-overlay">
            <div class="spinner"></div>
            <p>Đang tải lên...</p>
          </div>
          <div class="box-images text-box-a profile-file-list" v-if="profile_info && profile_info.files && profile_info.files.length > 0">
            <div class="profile-file-row" v-for="(item, index) in profile_info.files" :key="index" >
              <a href="#" class="profile-file-link" @click.prevent="viewFile(item)">{{item.name}}</a>
              <Button icon="pi pi-download" class="p-button-download p-button-link" @click="downloadFile(item)"/>
              <Button icon="pi pi-trash" class="p-button-secondary p-button-link text-danger" @click="onFileClear2(index)"/>
            </div>
          </div>
        </div>
        <template #footer>
          <Button label="Hủy" @click="showEditDialog = false" icon="pi pi-times" class="p-button-cancel-2"/>
          <Button type="button" label="Xác nhận" @click="EditData()" icon="pi pi-check" class="" />
        </template>
      </Dialog>

    </div>
  </form>
</template>

<script>
import DropdownScrollable from '@/components/DropdownScrollable_v2.vue';
import ApiRepository from "@/core/ApiRepository";

export default {
  components:{
    DropdownScrollable
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      is_required : true,
      filters: {},
      maxFileSize: 10485760*5,//1024*1024*50 = 50MB
      maxFiles : 100,
      name: "",
      active: true,
      company: {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      owner_name : "",
      email : "",
      code : "",
      phone : "",
      maxFilesProfile: 100,
      list_profile : [
        // {
        //   id : 1,
        //   name : "Giấy phép đăng ký kinh doanh",
        //   files : []
        // },
        // {
        //   id : 2,
        //   name : "Giấy phép hoạt động",
        //   files : []
        // },
        // {
        //   id : 3,
        //   name : "Kế hoạch an toàn vệ sinh lao động của nhà thầu",
        //   files : []
        // },
        // {
        //   id : 4,
        //   name : "Chứng chỉ, chứng nhận liên quan đến an toàn lao động",
        //   files : []
        // }
      ],
      profile_info : null,
      showEditDialog : false,
      index_update : -1,
      filesDeletes : [],
      edit_id : null,
      filesDeletes2 : [],
      filesDeletes2_tmp : [],
      service_text : "",
      users1_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      selusers1 : null,
      zone: null,
      zone_obj: {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
      },
    };
  },
  computed: {
    isView() {
      return this.mode == 'view';
    },
  },
  async mounted() {
    await this.getListCompany();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.is_required = false;
      if (this.$route.params.id !== undefined) this.edit_id = this.$route.params.id;
      console.log("this.model====",this.model)
      this.company = this.model.company;
      this.code = this.model.code;
      this.name = this.model.name;
      this.owner_name = this.model.owner_name;
      this.phone = this.model.phone;
      this.email = this.model.email;
      this.active = this.model.active;
      this.service_text = this.model.service_text;
      if(this.model.manager_id){
        this.selusers1 = {
          id : this.model.manager_id,
          fullname : this.model.manager_fullname,
          name : this.model.manager_fullname,
        }
      }
      this.getListUsers1();
      this.zone = this.model.zone || (this.model.zone_id ? { id: this.model.zone_id, name: this.model.zone_name } : null);
      this.getListZone();
    } else {
          if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
              this.$set(this, 'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
              this.company = { id: this.$store.getters?.company_id };
          }
      }
  },
  watch: {
    async "company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.company = {id: this.company_id};
        await this.getListDocumentFileAll();
        await this.getListUsers1();
        await this.getListZone();
      }
    },
    async "$store.getters.company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
        this.company = {id: this.company_id};
        await this.getListDocumentFileAll();
        await this.getListUsers1();
        await this.getListZone();
      }
    },
    async "company"() {
      console.log("company change");
      await this.getListDocumentFileAll();
      if (this.mode == "edit" && this.loadKey == 0) {
        this.loadKey++;
      }
      if(this.mode == 'add'){
        this.users1_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        }
        this.selusers1 = null;
        this.zone_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        }
        this.zone = null;
        await this.getListUsers1();
        await this.getListZone();
      }
    }
  },
  methods: {
    backToList() {
      this.$emit("back");
    },
    async emitEvent(keyword) {
      this.$delete(this.filters, 'name');
      if (keyword) {
        this.filters.name = keyword;
      }
      await this.getListCompany();
    },
    async changeOffset(value) {
      this.offset = value;
      // await this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.filters, limit: 20, offset: this.offset}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.items.push(...res.data.data.company);
          } else {
            this.items = res.data.data.company;
          }
          this.total = res.data.data.total;
          this.loading = false;
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },
    async validateData() {
      this.validationErrors = {};
      if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
        let company_add = document.getElementById("company");
        if (
          this.$commonFuction.isEmptyObject(this.company) ||
          this.$commonFuction.isEmpty(this.company)
        ) {
          company_add.setCustomValidity("Công ty không được để trống!");
        } else {
          company_add.setCustomValidity("");
        }
      }
      if(this.mode == 'add'){
        let code_add = document.getElementById("code_add");
        if (this.code == undefined || this.code == null || this.code == "") {
          code_add.setCustomValidity("Mã nhà thầu không được để trống!");
        } else if (this.code.length > 50) {
          code_add.setCustomValidity("Mã nhà thầu không được quá 50 ký tự!");
        } else if(await this.existcode()){
          code_add.setCustomValidity("Mã nhà thầu đã tồn tại!");
        }else {
          code_add.setCustomValidity("");
        }
      }
      let name_add = document.getElementById("name_add");
      if (this.name == undefined || this.name == null || this.name == "") {
        name_add.setCustomValidity("Vui lòng nhập tên nhà thầu!");
      } else if (this.name.length > 255) {
        name_add.setCustomValidity("Tên nhà thầu không được quá 255 ký tự!");
      } else {
        name_add.setCustomValidity("");
      }
      // let owner_name_add = document.getElementById("owner_name_add");
      // if (this.owner_name == undefined || this.owner_name == null || this.owner_name == "") {
      //   owner_name_add.setCustomValidity("Vui lòng nhập tên người quản lý!");
      // } else if (this.owner_name.length > 255) {
      //   owner_name_add.setCustomValidity("Tên người quản lý không được quá 255 ký tự!");
      // } else {
      //   owner_name_add.setCustomValidity("");
      // }

      let phone_add = document.getElementById("phone_add");
      if (this.phone == undefined || this.phone == null || this.phone == "") {
        phone_add.setCustomValidity("Vui lòng nhập SĐT!");
      } else if (this.phone.length > 15) {
        phone_add.setCustomValidity("Số điện thoại không được quá 15 ký tự!");
      } else if(!this.isValidPhoneNumber()){
        phone_add.setCustomValidity("Số điện thoại không đúng định dạng!");
      } 
      // else if(await this.CheckExist()){
      //   phone_add.setCustomValidity("Số điện thoại đã tồn tại!");
      // }
      else {
        phone_add.setCustomValidity("");
      }

      let email_add = document.getElementById("email_add");
      if (this.email == undefined || this.email == null || this.email == "") {
        email_add.setCustomValidity("");
      } else if (!this.validateEmail()) {
        email_add.setCustomValidity("Email không đúng định dạng!");
      } 
      else if (await this.CheckExist()) {
         email_add.setCustomValidity("Email đã tồn tại!");
      } 
      else {
        email_add.setCustomValidity("");
      }

      // let selusers1_add = document.getElementById("selusers1_add");
      // if (
      //   this.$commonFuction.isEmptyObject(this.selusers1) ||
      //   this.$commonFuction.isEmpty(this.selusers1)
      // ) {
      //   selusers1_add.setCustomValidity("Vui lòng chọn người phụ trách nhà thầu!");
      // } else {
      //   selusers1_add.setCustomValidity("");
      // }

      // let zone_add = document.getElementById("zone");
      //   if (
      //       this.$commonFuction.isEmptyObject(this.zone) ||
      //       this.$commonFuction.isEmpty(this.zone)
      //   ) {
      //       zone_add.setCustomValidity("Vui lòng chọn khu vực!");
      //   } else {
      //       zone_add.setCustomValidity("");
      //   }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }

      var params = {
        code: this.code,
        name: this.name,
        owner_name : this.owner_name,
        phone : this.phone,
        email: this.email,
        active: this.active,
        company: this.company,
        list_profile : this.list_profile,
        files_deleted : this.filesDeletes2,
        manager : this.selusers1 ? this.selusers1 : null,
        service_text : this.service_text,
        zone: this.zone,
      };
      console.log("saveData", params);
      this.$commonFuction.is_loading(false);
      this.$emit("save", params);
    },
    ShowUpload(index){
      this.index_update = -1;
      const profile = this.list_profile[index];
      this.index_update = index;
      this.profile_info = {
        id : profile.id,
        name : profile.name,
        files : profile.files ? JSON.parse(JSON.stringify(profile.files)) : [],
        document_files_contractor_id : profile.document_files_contractor_id ?? null,
      }
      this.filesDeletes2_tmp = []
      this.showEditDialog = true
    },
    async onFileSelect(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (files.length > 0) {
        if (files.length > this.maxFiles) {
          event.target.value = "";
          alert("Chỉ được upload tối đa "+this.maxFiles+" file");
          return;
        }
        let acceptTags = [
          "docx", "doc", "xlsx", "pptx", "pdf","xls",
          "DOCX", "DOC", "XLSX", "PPTX", "PDF","XLS",
        ];
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            event.target.value = ""
            alert(
              "Vui lòng upload file có định dạng là: docx, doc, xlsx, pptx, pdf."
            );
            return;
          }
        }
        if (files.length + this.profile_info.files.length > this.maxFiles) {
          event.target.value = "";
          alert("Số lượng tối đa là " + this.maxFiles + " files");
          return;
        } else {
          var arrTemp = [],
            arrFiles = [];
          for (let file of files) {
            console.log(file.type);
            // this.isImage(file){
              if (file.size <= this.maxFileSize) {
                file.source = file;
                file.objectURL = window.URL.createObjectURL(file);
                file.is_new = true;
                arrTemp.push(file);
              }else{
                arrFiles.push(file);
              }
            // }
          }
          console.log("arrTemp",arrTemp)
          if (arrFiles.length > 0) {
            event.target.value = "";
            alert("File của bạn đã quá dung lượng 50MB");
            return;
          } else {
            // this.files = this.files.concat.apply(this.files, arrTemp);
            this.profile_info.files = this.profile_info.files.concat.apply(this.profile_info.files, arrTemp);
          }
        }
      }
      console.log("this.profile_info",this.profile_info)
      event.target.value = "";
      return;
    },
    async onFileSelect2(event) {
      let files = event.target.files || event.dataTransfer.files;
      this.loading = true;
      if (files.length > 0) {
        if (files.length > this.maxFilesProfile) {
          event.target.value = "";
          this.loading = false;
          alert("Chỉ được upload tối đa "+this.maxFilesProfile+" file");
          return;
        }
        let acceptTags = [
          "docx", "doc", "xlsx", "pptx", "pdf","xls",
          "DOCX", "DOC", "XLSX", "PPTX", "PDF","XLS",
          "png", "jpg", "jpeg", "PNG", "JPG", "JPEG",
        ];
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            event.target.value = ""
            this.loading = false;
            alert(
              "Vui lòng upload file có định dạng là: docx, doc, xlsx, pptx, pdf, png, jpg, jpeg."
            );
            return;
          }
        }
        if (files.length + this.profile_info.files.length > this.maxFilesProfile) {
          event.target.value = "";
          this.loading = false;
          alert("Số lượng tối đa là " + this.maxFilesProfile + " files");
          return;
        } else {
          var arrTemp = [],
            arrFiles = [];
          for (let file of files) {
            console.log(file.type);
            // this.isImage(file){
              if (file.size <= this.maxFileSize) {
                file.source = file;
                file.objectURL = window.URL.createObjectURL(file);
                file.is_new = true;
                arrTemp.push(file);
              }else{
                arrFiles.push(file);
              }
            // }
          }
          // console.log("arrTemp",arrTemp)
          if (arrFiles.length > 0) {
            event.target.value = "";
            this.loading = false;
            alert("File của bạn đã quá dung lượng 50MB");
            return;
          } else {
            // this.files = this.files.concat.apply(this.files, arrTemp);
            console.log("arrTemp===",arrTemp);
            var tmp_add = []
            await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.DOCUMENT_FILES, arrTemp).then((resImage)=> {
              tmp_add = resImage
            })

            // for (let m = 0; m < tmp_add.length; m++) {
            //   let url = tmp_add[m].url
            //   let split = url.split('/')
            //   let fileName = split[split.length - 1]
            //   tmp_add[m].name = fileName;
            // }
            // console.log("tmp_add=========",tmp_add)
            this.profile_info.files = this.profile_info.files.concat.apply(this.profile_info.files, tmp_add);
          }
        }
      }
      console.log("this.profile_info",this.profile_info)
      event.target.value = "";
      this.loading = false;
      return;
    },
    async EditData(){
      // console.log("this.profile_info",this.profile_info)
      // console.log("index_update",this.index_update)
      const tmp = this.profile_info
      if(this.index_update >= 0){
        this.list_profile[this.index_update] = tmp;
      }
      this.showEditDialog = false
      this.profile_info = null;
      // console.log("filesDeletes2_tmp===",this.filesDeletes2_tmp)
      this.filesDeletes2 = this.filesDeletes2.concat(this.filesDeletes2_tmp);
      // console.log("t.list_profile",this.list_profile)
    },
    downloadFile(file) {
      const fileUrl = file ? (file.url || file.objectURL) : null;
      if (!fileUrl) return;

      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = file.name || fileUrl.split("?")[0].split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    onFileClear(index) {
      let file = this.profile_info.files[index];
      this.profile_info.files.splice(index, 1);
      if (file.file === "" && file.id) this.filesDeletes.push(file.id);
    },
    onFileClear2(index) {
      let file = this.profile_info.files[index];
      this.profile_info.files.splice(index, 1);
      if (file && file.is_old==true) this.filesDeletes2_tmp.push(file.id);
    },
    validateEmail() {
      var re =  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.email);
    },
    async CheckExist(){
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var objects = {
          email : this.email,
          company_id : this.company.id,
          id : this.edit_id,
        }
        var {data} = await ApiRepository.post("/_api/contractor/check_exist", objects, {headers});
        var contractor = data.data ?? null;
        if (contractor) {
          return true;
        }
        return false;
      }
    },
    isValidPhoneNumber() {
      var phone = this.phone;
      // kiểm tra định dạng số điện thoại
      const phoneRegex = /^\+?[0-9]{10,15}$/;
      return phoneRegex.test(phone);
    },
    async existcode() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var objects = {
          code: this.code,
          company_id : this.company.id,
          edit_id: this.edit_id
        }
        var {data} = await ApiRepository.post("/_api/contractor/check_code", objects, {headers});
        var contractor = data.data ?? null;
        // console.log("contractor====",contractor)
        if (contractor) {
          return true;
        }
        return false
      }
    },
    async getListDocumentFileAll() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.updateListProfile([])
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        await ApiRepository.post("/_api/document_files/all", {type : 'CONTRACTOR_PROFILE' ,object_id : this.edit_id, company_id: this.company.id}, {headers}).then((res) => {
            var tmp_df = res.data.data.document_files ?? []
            // console.log("tmp_df===",tmp_df)
            this.updateListProfile(tmp_df)
        }).catch((err) => {
            console.log(err);
        })
      }
    },
    updateListProfile(list=[]){
      var tmp = []
      for (let i = 0; i < list.length; i++) {
        let files = list[i].files ?? []
        let tm = {
          id : list[i].id,
          name : list[i].name,
          document_files_contractor_id : list[i].document_files_users_id ?? null,
          files : files,
        }
        tmp.push(tm)
      }
      // console.log("tmp===",tmp)
      this.list_profile = tmp
    },
    async viewFile(file) {
      const fileUrl = file ? (file.url || file.objectURL) : null;
      if (!fileUrl) return;

      const fileName = file.name || fileUrl.split("?")[0].split("/").pop() || "";
      const extension = fileName.toLowerCase().split(".").pop();
      const imageMimeTypes = {
        jpg: "image/jpeg", jpeg: "image/jpeg", png: "image/png",
        gif: "image/gif", webp: "image/webp", bmp: "image/bmp",
        svg: "image/svg+xml", tif: "image/tiff", tiff: "image/tiff",
      };
      const isPdf = extension === "pdf";
      const isImage = Object.prototype.hasOwnProperty.call(imageMimeTypes, extension);

      if (!isPdf && !isImage) {
        window.open(fileUrl, "_blank", "noopener,noreferrer");
        return;
      }

      const previewWindow = window.open("", "_blank");
      if (!previewWindow) {
        alert("Vui lòng cho phép trình duyệt mở cửa sổ mới để xem file.");
        return;
      }

      previewWindow.opener = null;

      try {
        const response = await fetch(fileUrl);
        if (!response.ok) throw new Error(`Không thể tải file (${response.status})`);

        const blob = await response.blob();
        const previewMimeType = isPdf ? "application/pdf" : imageMimeTypes[extension];
        const previewBlob = blob.type === previewMimeType
          ? blob
          : new Blob([blob], { type: previewMimeType });
        const blobUrl = URL.createObjectURL(previewBlob);

        previewWindow.location.href = blobUrl;
        const cleanupInterval = window.setInterval(() => {
          if (previewWindow.closed) {
            window.clearInterval(cleanupInterval);
            URL.revokeObjectURL(blobUrl);
          }
        }, 5 * 1000);
      } catch (e) {
        previewWindow.close();
        console.error("Lỗi xem file:", e);
        alert("Không thể mở file. Máy chủ lưu file có thể chưa cho phép truy cập CORS.");
      }
    },
    emitEventUsers1(keyword) {
      // console.log(keyword);
      this.$delete(this.users1_obj.filters, 'name');
      if (keyword) {
        this.users1_obj.filters.name = keyword;
      }
      this.getListUsers1();
    },
    changeOffsetUsers1(value) {
      this.users1_obj.offset = value;
    },
    async getListUsers1() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      console.log("getListUsers1===================");
      console.log("this.company",this.company);
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.users1_obj.loading = true;
        await ApiRepository.post("/_api/users/options", {filters: this.users1_obj.filters, limit: this.users1_obj.limit, offset: this.users1_obj.offset, company_id: this.company.id, type_company : 'internal'}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            for (let i = 0; i < tmp.length; i++) {
              tmp[i].name = tmp[i].fullname 
            }
            if (this.users1_obj.offset > 0 ) {
              this.users1_obj.items.push(...tmp);
            } else{
              this.users1_obj.items = tmp;
            }
            
            this.users1_obj.total = res.data.data.count;
            this.users1_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.users1_obj.loading = false;
        })
      }
    },
    emitEventZone(keyword) {
          this.$delete(this.zone_obj.filters, 'name');
          if (keyword) {
              this.zone_obj.filters.name = keyword;
          }
          this.getListZone();
      },
      changeOffsetZone(value) {
          this.zone_obj.offset = value;
      },
      async getListZone() {
          if (this.$commonFuction.isEmptyObject(this.company)) {
              this.zone_obj = {
                  offset: 0,
                  filters: {},
                  limit: 20,
                  items: [],
                  total: 0,
                  loading: false
              };
              return;
          }
          var token = this.$store.getters.token ? this.$store.getters.token : null;
          if (token) {
              const headers = {
                  "Authorization": "Bearer "+token,
              };
              this.zone_obj.loading = true;
              await ApiRepository.post("/_api/zone/options", {filters: this.zone_obj.filters, limit: this.zone_obj.limit, offset: this.zone_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
                  var tmp = res.data.data?.zone ?? [];
                  if (this.zone_obj.offset > 0) {
                      this.zone_obj.items.push(...tmp);
                  } else {
                      this.zone_obj.items = tmp;
                  }
                  this.zone_obj.total = res.data.data.count ?? res.data.data.total ?? 0;
                  this.zone_obj.loading = false;
              }).catch((err) => {
                  console.log(err);
                  this.zone_obj.loading = false;
              });
          }
      },
  },
  
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-checkbox {
  margin-right: 1rem !important;
}
.f-grid {
  display: flex;
  justify-content: space-between;
  margin-left: -1rem;
  flex-flow: row wrap;
}
.f-grid-col {
  flex: 1 0;
  /* background-color: #EEEEEE; */
  padding: 0rem 1rem 0rem 1rem;
  border-radius: 5px;
}
#customers {
  border-collapse: collapse;
  width: 100%;
}
.cs-width {
  width : 100% !important;
}
.cs-input {
  width : 100%;
  /* max-width: 400px !important; */
}
.title-css { 
  font-weight: bold;
}
#tb_level {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#tb_level td, #customers th {
  border: 1px solid #ddd;
  padding: 6px;
}
#tb_level th {
  border: 1px solid #ddd;
  padding-top: 6px;
  padding-bottom: 6px;
  text-align: left;
  padding-left: 5px;
}
.p-button-cancel-2 {
  color : #333333;
  background-color : #F2F3F7;
  border: 1px solid #F2F3F7;
}
.profile-file-list {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.profile-file-row {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 4px;
}
.profile-file-link {
  display: block;
  max-width: 100%;
  color: #0086C4;
  text-decoration: underline;
  overflow-wrap: anywhere;
  cursor: pointer;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 5px solid #ccc;
  border-top: 5px solid #42b983;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.input_tmp_validator_r {
  display : block;
  width: 0px !important;
  height: 0px !important;
  background-color: #ffffff;
  border: unset;
  outline: unset;
  left: 1em;
}
</style>
